/**
 * calc-auth.js
 * Place in: assets/calc-auth.js
 * Load in: layout/theme.liquid (once, before closing </body> tag)
 *
 * Provides the CalcAuth global used by every calculator's saveState() function.
 * No calculator file needs to define this logic — it lives here and is shared.
 */

var CalcAuth = (function() {

  function prompt() {
    var overlay = document.getElementById('calcAuthOverlay');
    if (overlay) {
      // Build a login URL that returns the user to the current calculator page.
      // Shopify's return_to only accepts a relative path, so we use pathname + search.
      var returnPath = window.location.pathname + window.location.search;
      var loginUrl = '/customer_authentication/login?return_to=' + encodeURIComponent(returnPath);
      // Point both modal buttons at it (they share the same destination; Shopify
      // detects new vs returning users automatically).
      var btns = overlay.querySelectorAll('.calc-auth-btn');
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('href', loginUrl);
      }
      overlay.style.display = 'flex';
      // trap focus inside modal
      if (btns.length) btns[0].focus();
    }
  }

  function dismiss() {
    var overlay = document.getElementById('calcAuthOverlay');
    if (overlay) overlay.style.display = 'none';
  }

  // Close on overlay background click
  document.addEventListener('click', function(e) {
    var overlay = document.getElementById('calcAuthOverlay');
    if (overlay && e.target === overlay) dismiss();
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') dismiss();
  });

  return {
    prompt: prompt,
    dismiss: dismiss
  };

})();